module.exports = __webpack_public_path__ + "img/8th hakurei shrine fall reitaisai.5125274e.png";